import React from 'react';
import { CheckIcon } from 'src/assets/dynamicSvg';
import { InfoIcon, Poppins } from 'src/common';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .summary-item {
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-gap: 6px;

    svg {
      transform: scale(0.8);
    }
  }
`;

interface SummaryProps {
  isCompleted?: boolean;
  items: string[];
}

export const SCVSummary: React.FC<SummaryProps> = ({ items, isCompleted }) => {
  return (
    <Div>
      {items.map((item) => (
        <div className="summary-item" key={item}>
          <CheckIcon color={isCompleted ? 'statusGreen' : 'cflowerBlue'} />
          <Poppins px={14}>{item}</Poppins>
        </div>
      ))}
    </Div>
  );
};
